// @flow
import React, { useEffect } from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

// import LogoLight from "../../assets/images/logo.png";
import LogoDark from "../../assets/images/logo-dark.png";
import LogoLight from "../../assets/images/logo-light.png";

const AccountLayout = ({ bottomLinks, children }) => {
  useEffect(() => {
    if (document.body) document.body.classList.add("authentication-bg");

    return () => {
      if (document.body) document.body.classList.remove("authentication-bg");
    };
  }, []);

  const { t } = useTranslation();

  return (
    <>
      <div className="auth-fluid">
        {/* Auth fluid left content */}
        <div className="auth-fluid-form-box">
          <div className="align-items-center d-flex h-100">
            <Card.Body>
              {/* logo */}
              <div className="auth-brand text-center text-lg-start">
                <Link to="/">
                  <span>
                    <img src={LogoLight} alt="" height="40" />
                  </span>
                </Link>
                {/* <Link to="/">
                  <span>
                    {console.log("LogoLight: ", LogoLight)}
                    <img src={LogoDark} alt="Line Up Logo" height="40" />
                  </span>
                </Link> */}
              </div>

              {children}

              {/* footer links */}
              {bottomLinks}
            </Card.Body>
          </div>
        </div>

        {/* Auth fluid right content */}
        <div className="auth-fluid-right text-center">
          <div className="auth-user-testimonial">
            <h2 className="mb-3">{t("Line Up Headquarter")}</h2>
            <p className="lead">
              <i></i> {t("Mönchengladbach, Germany")} <i></i>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccountLayout;
